import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, CardHeader, CircularProgress } from '@material-ui/core'
import { FaCheck, FaUser, FaDownload, FaEyeSlash, FaPiggyBank, FaPercent } from 'react-icons/fa'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { show } from '../../../store/actions/cotas.action'
import { IoLogoWhatsapp } from "react-icons/io"
import Fullname from '../../components/Fullname'
import { redirectView } from '../../../store/actions/transaction.action'

export default function Detail(props) {
    const dispatch = useDispatch()
    const id = (props.uid) ? props.uid : null;
    const view = (props.view) ? props.view : null;
    const { cota } = useSelector(state => state.cotasReducer)

    const [isLoading, setLoading] = React.useState(true)
    const [ telefone, setTelefone ] = React.useState(false)

    React.useEffect(() => {
        dispatch(show(id, (view === 'list-editor'))).then(() => {
            setLoading(false)
        })
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    const _handleRedirectView = (id, url) => {
        dispatch(redirectView(id, url))
    }

    return (
        <>
            {isLoading ? <div className="d-flex justify-content-center p-5 bs-bg"><div className="text-center"><CircularProgress /></div></div> :
                <div className="card bs-bg">
                    <label className="card-body label-custom m-0 pb-1 bs-color-b">{cota.title ? cota.title : 'Cota'}</label>
                    <CardHeader 
                        avatar={
                            <Avatar className="bg-success">
                                <FaCheck />
                            </Avatar>
                        }
                        title={<h3 className="fw-semibold m-0 bs-color-b">{cota.quota_number}</h3>}
                        subheader={(cota.user_id) ? <small className="fw-bold text-success">VENDIDA</small> : <small className="fw-bold text-success">DISPONIVEL</small>} 
                    />

                    {cota.position &&
                        <CardHeader 
                            avatar={
                                <Avatar className="avatar-item">
                                    <FaPercent />
                                </Avatar>
                            }
                            title={<h5 className="fw-bold m-0 bs-color-b">{cota.position}</h5>}
                            subheader={<small className="fw-bold bs-color">porcento</small> } 
                        />
                    }

                    {(cota.user_id) &&
                        <>
                            <hr className="hr-muted m-0"/>
                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaUser /> 
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b">{<Fullname enabled fullName={cota.user_name ? cota.user_name.substring(0,25) : cota.user_name} />}</h6>}
                                subheader={
                                    <>
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex flex-column mb-2">
                                                <span className="d-block pointer bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? cota.user_telefone : <> {cota.user_telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                                            
                                                {cota?.location &&
                                                    <span className="bs-color">{cota?.location?.estado}</span>
                                                }
                                            </div>

                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+cota.user_telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>

                                        <span onClick={() => handlePage('shopping', cota.user_id)} className="pointer fw-bold text-danger">Todas compras</span>
                                    </>
                                } 
                            />

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaDownload />
                                    </Avatar>
                                }
                                title={
                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cota.detail.transaction_amount)}</h6>}
                                subheader={
                                    <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {month: '2-digit',day: '2-digit'}).format(new Date(cota.time_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(cota.time_at))}</span>
                                }
                            />

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaPiggyBank />
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cota.transaction_total.total)}</h6>}
                                subheader={
                                    <span className="d-block bs-color">Compras: {cota.transaction_total.count.toLocaleString('pt-BR', {style: 'decimal'})}</span>
                                }
                            />

                            <div className="alert alert-success pt-1 pb-1 m-3 mt-3 mb-1" role="alert">
                                <p className="mb-0">
                                    <strong>Título contemplado na modalidade Premiação Instantânea.</strong>
                                </p>
                            </div>
                        </>
                    }
                    
                    <div className="d-flex justify-content-center card-body">
                        <button className="btn btn-light fw-bold" onClick={() => props.onClose() }>
                            Fechar
                        </button>

                        {cota?.detail?.id &&
                            <button className="ms-3 btn btn-warning fw-bold" onClick={() => _handleRedirectView(cota?.detail?.id, cota?.campaign_url) }>
                                Ver Compra
                            </button>
                        }
                    </div>
                </div>
            }
        </>
    )
}